import xml2js from 'xml2js';

interface DymoLibOptions {
  hostname?: string;
  port?: number;
  printerName?: string;
}

interface ParsedPrinters {
  Printers: {
    LabelWriterPrinter?: unknown[];
  };
}

class DymoLib {
  hostname: string;
  port: number;
  printerName: string | undefined;

  constructor(options?: DymoLibOptions) {
    options = options || {};
    this.hostname = options.hostname || 'localhost';
    this.port = options.port || 41951;
    this.printerName = options.printerName;
  }

  get apiUrl(): string {
    return `https://${this.hostname}:${this.port}/DYMO/DLS/Printing`;
  }

  print(printerName: string, labelXml: string): Promise<boolean> {
    let label = `printerName=${encodeURIComponent(
      printerName,
    )}&printParamsXml=&labelXml=${encodeURIComponent(labelXml)}&labelSetXml=`;

    let url = `${this.apiUrl}/PrintLabel`;
    return fetch(url, {
      method: 'POST',
      body: label,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then((response) => {
        return response.text();
      })
      .then((result) => {
        return result === 'true';
      });
  }

  getPrinters(): Promise<unknown[] | void> {
    let url = `${this.apiUrl}/GetPrinters`;
    return fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((result) => {
        return parseResponse(result).then((parsed: ParsedPrinters) => {
          const printers = parsed.Printers;
          return printers.LabelWriterPrinter ? printers.LabelWriterPrinter : [];
        });
      })
      .catch((err) => console.log(err));
  }
}

function parseResponse(response: string): Promise<any> {
  return new Promise((resolve, reject) => {
    return xml2js.parseString(response, function (err: Error | null, json: unknown) {
      if (err) reject(err);
      else resolve(json);
    });
  });
}

export default new DymoLib({ hostname: '127.0.0.1' });
